(function(window){

	const $ = require('jquery');
	window.jQuery = $;
	window.$ = $;

	const ga = require('./modules/google-analytics.js');
	const slider = require("./modules/slider.js");
	const gallery = require("./modules/gallery.js");
	const menu = require("./modules/menu.js");
	const email = require("./modules/email.js");
	const quoteForm = require("./modules/quote-form.js");

	//ga('UA-XXXXXX-X');

})(window);
